// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"296":"privacy","443":"about","845":"profile","929":"terms","976":"tool"}[chunkId] || chunkId) + "." + {"296":"f907a41c","403":"1bdfdadd","443":"0341a4d9","541":"d88f16b0","845":"93a8b933","929":"b0fd304e","976":"4f6d9055"}[chunkId] + ".js";
};